export default {
  "mainVegetable": "vegetais",
  "mainVegetable/01": "vegetais/beringelas",
  "mainVegetable/02": "vegetais/espargos",
  "mainVegetable/03": "vegetais/abacates",
  "mainVegetable/04": "vegetais/beterrabas",
  "mainVegetable/05": "vegetais/brocolos",
  "mainVegetable/06": "vegetais/cenouras",
  "mainVegetable/07": "vegetais/aipo",
  "mainVegetable/08": "vegetais/cogumelos",
  "mainVegetable/09": "vegetais/couve",
  "mainVegetable/10": "vegetais/couve-de-bruxelas",
  "mainVegetable/11": "vegetais/couve-chinesa",
  "mainVegetable/12": "vegetais/couve-flor",
  "mainVegetable/13": "vegetais/coleslaw",
  "mainVegetable/14": "vegetais/pepino",
  "mainVegetable/15": "vegetais/curgetes",
  "mainVegetable/16": "vegetais/endivias",
  "mainVegetable/17": "vegetais/espinafres",
  "mainVegetable/18": "vegetais/favas",
  "mainVegetable/19": "vegetais/feijao-branco",
  "mainVegetable/20": "vegetais/feijao-verde-plano",
  "mainVegetable/21": "vegetais/feijao-seco",
  "mainVegetable/22": "vegetais/feijao-verde",
  "mainVegetable/23": "vegetais/lentilhas",
  "mainVegetable/24": "vegetais/macedonia-de-legumes",
  "mainVegetable/25": "vegetais/milho",
  "mainVegetable/26": "vegetais/mesclun",
  "mainVegetable/27": "vegetais/nabos",
  "mainVegetable/28": "vegetais/cebolas",
  "mainVegetable/29": "vegetais/edamame",
  "mainVegetable/30": "vegetais/pimentos",
  "mainVegetable/31": "vegetais/batatas",
  "mainVegetable/32": "vegetais/rebentos-de-soja",
  "mainVegetable/33": "vegetais/rabanetes",
  "mainVegetable/34": "vegetais/salada-folha-de-carvalho",
  "mainVegetable/35": "vegetais/salada-frisada",
  "mainVegetable/36": "vegetais/salada-iceberg",
  "mainVegetable/37": "vegetais/salada-piemontesa",
  "mainVegetable/38": "vegetais/salada-de-arroz",
  "mainVegetable/39": "vegetais/salada-romana",
  "mainVegetable/40": "vegetais/rebentos",
  "mainVegetable/41": "vegetais/alface",
  "mainVegetable/42": "vegetais/alface-da-variedade-mache",
  "mainVegetable/43": "vegetais/rucula",
  "mainVegetable/44": "vegetais/cercefi",
  "mainVegetable/45": "vegetais/taboule",
  "mainVegetable/46": "vegetais/tomate",
  "mainVegetable/47": "vegetais/feijao-manteiga",
  "mainVegetable/48": "vegetais/grao-de-bico",
  "mainVegetable/49": "vegetais/alho-frances",
  "mainVegetable/50": "vegetais/abobora",
  "mainVegetable/51": "vegetais/feijao-encarnado",
  "mainVegetable/52": "vegetais/macas",
  "mainVegetable/53": "vegetais/castanhas",
  "mainVegetable/54": "vegetais/ameixas",
  "mainVegetable/55": "vegetais/jardineira",
  "mainVegetable/56": "vegetais/azeitonas-pretas",
  "mainVegetable/57": "vegetais/alcachofras",
  "mainVegetable/58": "vegetais/pimentos-vermelhos",
  "mainVegetable/59": "vegetais/feijao-verde-plano",
  "mainVegetable/60": "vegetais/legumes-primavera",
  "mainVegetable/61": "vegetais/ratatouille",
  "mainVegetable/62": "vegetais/cuscuz",
  "mainVegetable/63": "vegetais/tajine",
  "mainVegetable/64": "vegetais/caril-de-legumes",
  "mainVegetable/65": "vegetais/ervilha-de-quebrar",
  "mainVegetable/66": "vegetais/lentilhas-coral",
  "mainVegetable/67": "vegetais/quinoa",
  "mainVegetable/68": "vegetais/espelta",
  "mainVegetable/69": "vegetais/bulgur",
  "mainVegetable/70": "vegetais/bulgur",
  "mainVegetable/71": "vegetais/couve-roxa",
  "mainVegetable/72": "vegetais/kale",
  "mainVegetable/73": "vegetais/cerefolio",
  "mainVegetable/74": "vegetais/graos-e-sementes",
  "mainVegetable/75": "vegetais/leguminosas",
  "mainVegetable/76": "vegetais/batata-doce",
  "mainVegetable/77": "vegetais/abobora",
  "mainVegetable/78": "vegetais/azedas",
  "mainVegetable/79": "vegetais/feijoes",
  "mainVegetable/80": "vegetais/ervilhas-e-cenouras",
  "mainVegetable/81": "vegetais/ervilhas",
  "mainVegetable/82": "vegetais/edamame",
  "mainVegetable/83": "vegetais/cevada",
  "mainVegetable/84": "vegetais/salada-mista",
  "mainVegetable/85": "vegetais/chicoria",
  "mainVegetable/86": "vegetais/canonigos",
  "mainVegetable/87": "vegetais/alface-batavia",
  "mainVegetable/88": "vegetais/espinaca-baby",
  "mainVegetable/89": "vegetais",
  "mainVegetable/90": "vegetais",
  "mainVegetable/91": "vegetais",
  "mainVegetable/92": "vegetais",
  "mainVegetable/93": "vegetais",
  "mainVegetable/94": "vegetais",
  "mainVegetable/95": "vegetais",
  "mainVegetable/96": "vegetais",
  "mainVegetable/97": "vegetais",
  "mainVegetable/98": "vegetais",
  "productRange": "gamas",
  "productRange/4G_BIO": "gamas",
  "productRange/4G_SRP": "gamas",
  "productRange/CAN_A_POEL": "gamas",
  "productRange/CAN_SEC_BI": "gamas",
  "productRange/CAN_SEC_CO": "gamas",
  "productRange/CAN_SEC_CU": "gamas",
  "productRange/CAN_SEC_NA": "gamas",
  "productRange/CAN_VAPEUR": "gamas",
  "productRange/CAN_VEG_SA": "gamas",
  "productRange/CAN_VEG_SR": "gamas",
  "productRange/CLASSICVEG": "gamas",
  "productRange/COLDVEGE": "gamas",
  "productRange/COOKMUSH": "gamas",
  "productRange/CRUDITES": "gamas",
  "productRange/DE_NOS_PRO": "gamas",
  "productRange/DOYMUSHACC": "gamas",
  "productRange/DOYMUSHAPE": "gamas",
  "productRange/DRYVEGE": "gamas",
  "productRange/FROZENVEGE": "gamas",
  "productRange/FRZ_ASTUCE": "gamas",
  "productRange/FRZ_GRATIN": "gamas",
  "productRange/FRZ_KELLO": "gamas",
  "productRange/FRZ_LEG_CO": "gamas",
  "productRange/FRZ_PUREES": "gamas",
  "productRange/FRZ_VEG_BI": "gamas",
  "productRange/FRZ_VEG_SR": "gamas",
  "productRange/INDFROZVEG": "gamas",
  "productRange/JEUNES_POU": "gamas",
  "productRange/LAITUES": "gamas",
  "productRange/LOOP": "gamas",
  "productRange/LUNCH_BOWL": "gamas",
  "productRange/MACHE_BASE": "gamas",
  "productRange/MEL_LAITUE": "gamas",
  "productRange/MUSHNATEMI": "gamas",
  "productRange/MUSHNATENT": "gamas",
  "productRange/MUSHNATEPA": "gamas",
  "productRange/MUSHNATMIN": "gamas",
  "productRange/MUSHROOMS": "gamas",
  "productRange/SUNVEGE": "gamas",
  "productRange/TRAIT_CRUD": "gamas",
  "productRange/TRAIT_TABO": "gamas",
  "productRange/TUS_RECETA": "gamas",
  "productRange/WORLDVEGE": "gamas",
  "productRange/PREPARED_VEG": "gamas",
  "productRange/BEAN_SAUCE": "gamas",
  "productRange/BEANS": "gamas/feijao",
  "productRange/BIO": "gamas/bio",
  "productRange/BOND_KIDS": "gamas",
  "productRange/CAN_BIO": "gamas",
  "productRange/CAN_SEC_PR": "gamas",
  "productRange/CARTA_DELL": "gamas",
  "productRange/CAN_PETITS": "gamas",
  "productRange/CAN_BOCAL": "gamas",
  "productRange/CEREAL_CAN": "gamas",
  "productRange/CEREAL_FRZ": "gamas",
  "productRange/CEREALI": "gamas",
  "productRange/CEREALLEGR": "gamas",
  "productRange/COCCOLE": "gamas",
  "productRange/CORN": "gamas/milho",
  "productRange/CREATIF": "gamas",
  "productRange/FRANCAIS": "gamas",
  "productRange/FRZ_FRY_MI": "gamas",
  "productRange/FRZ_MELANG": "gamas",
  "productRange/FRZ_POELEE": "gamas",
  "productRange/INSALATE_D": "gamas",
  "productRange/INSALATONA": "gamas",
  "productRange/LE_REGIONA": "gamas",
  "productRange/LEGUMIO": "gamas",
  "productRange/MIXES_CORN": "gamas",
  "productRange/MONO_VEGE": "gamas",
  "productRange/MUSHROOMS  ": "gamas",
  "productRange/NATURA_IN": "gamas",
  "productRange/OTHER_VEG": "gamas/outros-vegetais",
  "productRange/PEAS": "gamas/ervilhas",
  "productRange/READY_FROZ": "gamas/refeicoes-prontas-congeladas",
  "productRange/SOUPS": "gamas",
  "productRange/SPINACH": "gamas/espinafres",
  "productRange/STEAM_CAN": "gamas",
  "productRange/STEAM_FRZ": "gamas",
  "productRange/STEAM_MIX": "gamas",
  "productRange/STUZZICHIA": "gamas",
  "productRange/TOUCHE": "gamas/un-toque-de",
  "productRange/TRAIT_SAL": "gamas",
  "productRange/TUS_RECETA ": "gamas/tus-recetas",
  "productRange/VEG_TO_FRY": "gamas",
  "productRange/VEGGIE": "gamas",
  "productRange/FRZ_JUSTEA": "gamas",
  "productRange/SALABIS": "gamas",
  "productRange/BON_SENGAG": "gamas",
  "productRange/CROUSTIS": "gamas",
  "season": "epocas",
  "season/1": "epocas/verao",
  "season/2": "epocas/outono",
  "season/3": "epocas/inverno",
  "season/4": "epocas/primavera",
  "season/5": "epocas",
  "technologie": "tecnologia",
  "technologie/AC01": "tecnologia/conserva",
  "technologie/AD01": "tecnologia/congelados",
  "technologie/AG01": "tecnologia/frescos",
  "technologie/AT01": "tecnologia/v-gama",
  "recipeDish": "tipo-de-prato",
  "recipeDish/ACC": "tipo-de-prato/acompanhamento",
  "recipeDish/APE": "tipo-de-prato/aperitivo",
  "recipeDish/DES": "tipo-de-prato/sobremesa",
  "recipeDish/ENT": "tipo-de-prato/entrada",
  "recipeDish/PLAT": "tipo-de-prato/prato",
  "recipeDish/SAL": "tipo-de-prato/salada",
  "recipeDish/SNA": "tipo-de-prato/snack",
  "recipeDish/PDE": "tipo-de-prato/pequeno-almoco",
  "recipeDish/DEJ": "tipo-de-prato/almoco",
  "recipeDish/TRA": "tipo-de-prato/tradicional",
  "recipeDish/GOU": "tipo-de-prato/refeicao-gourmet",
  "recipeDish/ETH": "tipo-de-prato/etnico",
  "recipeDish/FCH": "tipo-de-prato/para-criancas",
  "recipeDish/SOU": "tipo-de-prato",
  "pred-recipeTimingCook-facet": "culinaria",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "culinaria/0-15-minutos",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "culinaria/15-30-minutos",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "culinaria/30-45-minutos",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "culinaria/45-minutos",
  "pred-recipeTimingPreparation-facet": "preparacao",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "preparacao/0-15-minutos",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "preparacao/15-30-minutos",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "preparacao/30-45-minutos",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "preparacao/45-minutos",
  "pred-recipeCost-Facet": "custo",
  "pred-recipeCost-Facet/petit": "custo/barato",
  "pred-recipeCost-Facet/moyen": "custo/medio",
  "pred-recipeCost-Facet/grand": "custo/alto",
  "recipeDifficulty": "dificuldade",
  "recipeDifficulty/1": "dificuldade/facil",
  "recipeDifficulty/2": "dificuldade/medio",
  "recipeDifficulty/3": "dificuldade/dificil",
  "recipeDishNumber": "porcoes",
  "recipeDishNumber/1": "porcoes/1",
  "recipeDishNumber/2": "porcoes/2",
  "recipeDishNumber/3": "porcoes/3",
  "recipeDishNumber/4": "porcoes/4",
  "recipeDishNumber/5": "porcoes/5",
  "recipeDishNumber/6": "porcoes/6",
  "recipeDishNumber/7": "porcoes/7",
  "recipeDishNumber/8": "porcoes/8",
  "productTheme": "produtos-por-tema",
  "productTheme/ACC": "produtos-por-tema/acompanhamento",
  "productTheme/BEA": "produtos-por-tema/feijao",
  "productTheme/BIS": "produtos-por-tema/feijao-em-molho",
  "productTheme/BIO": "produtos-por-tema/bio",
  "productTheme/CAN": "produtos-por-tema/conserva",
  "productTheme/CER": "produtos-por-tema",
  "productTheme/CLS": "produtos-por-tema/classicos",
  "productTheme/DLE": "produtos-por-tema/vegetais",
  "productTheme/EDR": "produtos-por-tema/enriquecedores",
  "productTheme/ENT": "produtos-por-tema/aperitivos",
  "productTheme/FRZ": "produtos-por-tema/congelados",
  "productTheme/FSD": "produtos-por-tema/buffet-de-saladas",
  "productTheme/FSH": "produtos-por-tema/frescos",
  "productTheme/ING": "produtos-por-tema/ingredientes-para-as-minhas-receitas",
  "productTheme/JAR": "produtos-por-tema",
  "productTheme/LBW": "produtos-por-tema",
  "productTheme/LDF": "produtos-por-tema/vegetais-para-forno",
  "productTheme/LEG": "produtos-por-tema/as-leguminosas",
  "productTheme/LGO": "produtos-por-tema/legumio",
  "productTheme/LGR": "produtos-por-tema/legumes-grelhados",
  "productTheme/LGS": "produtos-por-tema",
  "productTheme/MAI": "produtos-por-tema/o-milho",
  "productTheme/MUS": "produtos-por-tema/cogumelos",
  "productTheme/NEW": "produtos-por-tema/novos-produtos",
  "productTheme/PDH": "produtos-por-tema/pratos-de-legumes-secos",
  "productTheme/PDL": "produtos-por-tema/cesta-de-vegetais",
  "productTheme/PHR": "produtos-por-tema/para-as-suas-receitas",
  "productTheme/PLP": "produtos-por-tema/prato-principal",
  "productTheme/RAL": "produtos-por-tema/arroz-vegetal",
  "productTheme/RDM": "produtos-por-tema/pronto-para-cozinhar",
  "productTheme/SAL": "produtos-por-tema/para-as-suas-saladas",
  "productTheme/SDB": "produtos-por-tema/saladeiras",
  "productTheme/SNK": "produtos-por-tema/petiscos",
  "productTheme/SUP": "produtos-por-tema/sopa",
  "productTheme/TEX": "produtos-por-tema/tex-mex",
  "productTheme/VGP": "produtos-por-tema/proteínas-vegetais",
  "recipeTheme": "receitas-por-tema",
  "recipeTheme/01": "receitas-por-tema/receitas-festivas",
  "recipeTheme/02": "receitas-por-tema/aperitivo",
  "recipeTheme/03": "receitas-por-tema/saladas-e-petiscos",
  "recipeTheme/04": "receitas-por-tema/sopa",
  "recipeTheme/05": "receitas-por-tema/quiches-e-gratinados",
  "recipeTheme/06": "receitas-por-tema/especial-para-criancas",
  "recipeTheme/07": "receitas-por-tema/sobremesa",
  "recipeTheme/08": "receitas-por-tema/vegetarianos",
  "recipeTheme/09": "receitas-por-tema/acompanhamento",
  "recipeTheme/10": "receitas-por-tema/come-from-away",
  "recipeTheme/11": "receitas-por-tema/guisados",
  "recipeTheme/12": "receitas-por-tema/saladas-e-barbecues",
  "recipeTheme/13": "receitas-por-tema/snack-and-fingerfood",
  "recipeTheme/14": "receitas-por-tema/prato-principal",
  "recipeTheme/15": "receitas-por-tema/sobremesas-e-pastelaria",
  "recipeTheme/16": "receitas-por-tema/entrada",
  "recipeTheme/17": "receitas-por-tema/salada",
  "recipeTheme/18": "receitas-por-tema/tacas",
  "recipeTheme/19": "receitas-por-tema/sopas",
  "recipeTheme/20": "receitas-por-tema/salgadinhos",
  "recipeTheme/21": "receitas-por-tema/molho",
  "recipeTheme/22": "receitas-por-tema/pratos-unicos",
  "recipeTheme/23": "receitas-por-tema/outros-pratos",
  "recipeTheme/24": "receitas-por-tema/pratos-au-forno",
  "recipeTheme/25": "receitas-por-tema",
  "recipeTheme/26": "receitas-por-tema",
  "recipeTheme/27": "receitas-por-tema",
  "recipeTheme/28": "receitas-por-tema",
  "recipeTheme/33": "receitas-por-tema",
  "recipeTheme/34": "receitas-por-tema",
  "recipeTheme/35": "receitas-por-tema",
  "recipeTheme/36": "receitas-por-tema",
  "recipeTheme/37": "receitas-por-tema",
  "recipeTheme/38": "receitas-por-tema",
  "recipeTheme/39": "receitas-por-tema",
  "recipeTheme/40": "receitas-por-tema",
  "recipeTheme/41": "receitas-por-tema",
  "recipeTheme/42": "receitas-por-tema",
  "recipeTheme/43": "receitas-por-tema",
  "recipeTheme/44": "receitas-por-tema",
  "recipeTheme/45": "receitas-por-tema",
  "recipeTheme/46": "receitas-por-tema",
  "pred-particularite": "habitos-alimentares",
  "pred-particularite/Sans%20conservateur": "habitos-culinarios/sem-conservantes",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "habitos-culinarios",
  "pred-particularite/Sans%20colorant": "habitos-culinarios/sem-corantes",
  "pred-particularite/Sans%20sucre%20ajout%E9": "habitos-culinarios/sem-adicao-de-acucar",
  "pred-particularite/Sans%20sel%20ajout%E9": "habitos-culinarios/sem-sal",
  "pred-particularite/Sans%20additif": "habitos-culinarios/sem-aditivos",
  "pred-particularite/": "habitos-culinarios/sal-natural",
  "pred-particularite/Sans%20lactose": "habitos-culinarios/sem-lactose",
  "pred-particularite/Sans%20gluten": "habitos-culinarios/sem-gluten",
  "pred-particularite/V%E9g%E9tarien": "habitos-culinarios/vegetariano",
  "pred-particularite/V%E9g%E9talien": "habitos-culinarios/vegano",
  "pred-particularite/Sans%20sulfite": "habitos-culinarios/sem-sulfitos",
  "pred-particularite/A%20la%20vapeur": "habitos-culinarios",
  "pred-particularite/Sans%20condiment": "habitos-culinarios",
  "cultureType": "tipo-de-colheita",
  "cultureType/Bio": "tipo-de-colheita/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "tipo-de-colheita/sem-residu-de-pesticidas",
  "cultureType/Sans%20OGM": "tipo-de-colheita/sem-ogm",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "habitos-alimentares/vegan",
  "pred-particularite/recipeVeggie": "habitos-alimentares/vegetariano",
  "pred-particularite/recipeGlutenfree": "habitos-alimentares/sem-gluten",
  "pred-particularite/recipeLactosefree": "habitos-alimentares/sem-lactose"
};
